<template>
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="font-size-h2 text-header-color text-center px-4">KIOSK IS NOT AVAILABLE ON THIS SITE.</div>
  </div>
</template>

<script>
export default {
  name: 'KioskNoSubscription'
}
</script>
